import { render, staticRenderFns } from "./DrawerMenu.vue?vue&type=template&id=2f0cc5bd&scoped=true"
import script from "./DrawerMenu.vue?vue&type=script&lang=js"
export * from "./DrawerMenu.vue?vue&type=script&lang=js"
import style0 from "./DrawerMenu.vue?vue&type=style&index=0&id=2f0cc5bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0cc5bd",
  null
  
)

export default component.exports